import { ControllerInterface } from "csi/action/Controller";
import { ModalDialogProps } from "designSystem/components/dialog/ModalDialog";
import { useSyncLocalStore } from "designSystem/hooks";
import React, { FunctionComponent } from "react";
import PresentationPopup from "./PresentationPopup";
import PresentationPopupStore, { PresentationPopupStoreContext } from "./PresentationPopupStore";

export interface PresentationProps extends ModalDialogProps {
	actionController: ControllerInterface;
}

const makePopupStore = (actionController) => {
	const node = actionController.getNode();

	return new PresentationPopupStore(node);
};

export const PresentationWrapper: FunctionComponent<PresentationProps> = (props) => {
	const store = useSyncLocalStore(() => makePopupStore(props.actionController));

	return (
		<PresentationPopupStoreContext.Provider value={store}>
			<PresentationPopup onClose={props.onClose} open />
		</PresentationPopupStoreContext.Provider>
	);
};

export default PresentationWrapper;